import { API_BASE_URL, API_MAJOR_VERSION } from "../../user/constant";
import { postJSON } from "../myAjax";
import humps from "humps";

export const charge = function charge(param) {
  return new Promise((resolve, reject) => {
    if (param.guess) {
      const distance = param.distance;
      const guess = param.guess;
      const payload = humps.decamelizeKeys({
        guess,
        distance
      });
      const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/restaurants/${param.restaurantId}/calculate_package_price.json`;
      try {
        postJSON(
          url,
          payload,
          result => {
            resolve(humps.camelizeKeys(result));
          },
          err => {
            reject(err);
          }
        );
      } catch (err) {
        reject(err);
      }
    } else {
      if (
        param.restaurantId !== undefined &&
        param.adult !== undefined &&
        param.packages.length > 0
      ) {
        const kids = param.kids || 0;
        const adult = param.adult;
        const packagesBought = param.packages;
        const distance = param.distance;
        const payload = humps.decamelizeKeys({
          adult,
          kids,
          distance,
          packageBought: packagesBought
        });
        const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/restaurants/${param.restaurantId}/calculate_package_price.json`;
        try {
          postJSON(
            url,
            payload,
            result => {
              resolve(humps.camelizeKeys(result));
            },
            err => {
              reject(err);
            }
          );
        } catch (err) {
          reject(err);
        }
      } else {
        reject("required paramater is missing");
      }
    }
  });
};
